// extracted by mini-css-extract-plugin
module.exports = {"container":"SubSection_container__2bguC","actions":"SubSection_actions__1AdLf","count":"SubSection_count__1QX-l","name":"SubSection_name__1dY7R"};